// @flow
import _ from 'lodash';
import { AttentiveAction } from 'stores/flow-type/attentive.type';
import {
  ATTENTIVE_STATUS,
  GET_ATTENTIVE_STATUS_REQUEST,
  GET_ATTENTIVE_STATUS_SUCCESS,
  GET_ATTENTIVE_STATUS_FAILURE,
  TOGGLE_ATTENTIVE_REQUEST,
  TOGGLE_ATTENTIVE_SUCCESS,
  TOGGLE_ATTENTIVE_FAILURE,
} from '../flow-type/attentive.type';

type AttentiveState = {
  status: string,
  getStatusLoading: boolean,
  getStatusSuccess: boolean,
  toggleStatusLoading: boolean,
  toggleStatusSuccess: boolean,
};

const initialState: AttentiveState = {
  status: ATTENTIVE_STATUS.INACTIVE,
  getStatusLoading: false,
  getStatusSuccess: false,

  toggleStatusLoading: false,
  toggleStatusSuccess: false,
};

const attentiveReducers = (state: AttentiveState = initialState, action: AttentiveAction) => {
  const { type } = action;

  switch (type) {
    case GET_ATTENTIVE_STATUS_REQUEST:
      return {
        ...state,
        getStatusSuccess: false,
        getStatusLoading: true
      };
    case GET_ATTENTIVE_STATUS_SUCCESS: {
      const { data } = action.payload;
      return {
        ...state,
        status: _.get(data, 'attentiveOAuth.status'),
        getStatusLoading: false,
        getStatusSuccess: true,
        error: undefined
      };
    }
    case GET_ATTENTIVE_STATUS_FAILURE:
      return {
        ...state,
        getStatusLoading: false,
        getStatusSuccess: false,
        error: action.payload
      };

    case TOGGLE_ATTENTIVE_REQUEST: {
      const status = action.payload;
      return {
        ...state,
        status,
        toggleStatusSuccess: false,
        toggleStatusLoading: true
      };
    }
    case TOGGLE_ATTENTIVE_SUCCESS: {
      const { data } = action.payload;
      return {
        ...state,
        status: _.get(data, 'data.attentiveOAuth.status'),
        toggleStatusLoading: false,
        toggleStatusSuccess: true,
        error: undefined
      };
    }
    case TOGGLE_ATTENTIVE_FAILURE:
      return {
        ...state,
        status: !state.status,
        toggleStatusLoading: false,
        toggleStatusSuccess: false,
        error: action.payload
      };
    default:
      return state;
  }
};

export default attentiveReducers;
